import React, { createContext, useContext, useState } from "react";
import ReviewsModal from "@/components/reviews/ReviewsModal";
import {
  trackReviewsModalOpen,
  trackReviewsModalClose,
} from "@/components/analytics/reviewsEvents";

const ReviewsContext = createContext(null);

export const useReviews = () => {
  const context = useContext(ReviewsContext);
  if (!context) {
    throw new Error("useReviews must be used within a ReviewsProvider");
  }
  return context;
};

export const ReviewsProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState({
    webDomain: null,
    affiliateLink: null,
    companyName: null,
    totalReviews: null,
    t: null,
  });

  const openReviewsModal = ({ webDomain, affiliateLink, companyName, totalReviews, t }) => {
    setModalData({ webDomain, affiliateLink, companyName, totalReviews, t });
    setIsOpen(true);
    trackReviewsModalOpen(companyName, webDomain);
  };

  const closeReviewsModal = () => {
    setIsOpen(false);
    trackReviewsModalClose(modalData.companyName, modalData.webDomain);
  };

  const handleOpenChange = (open) => {
    if (!open && isOpen) {
      trackReviewsModalClose(modalData.companyName, modalData.webDomain);
    }
    setIsOpen(open);
  };

  return (
    <ReviewsContext.Provider value={{ openReviewsModal, closeReviewsModal, isOpen }}>
      {children}
      <ReviewsModal
        open={isOpen}
        onOpenChange={handleOpenChange}
        webDomain={modalData.webDomain}
        affiliateLink={modalData.affiliateLink}
        companyName={modalData.companyName}
        totalReviews={modalData.totalReviews}
        t={modalData.t}
      />
    </ReviewsContext.Provider>
  );
};
